import React, {useMemo, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import usersStyle from "assets/jss/material-dashboard-pro-react/views/usersStyle";
import connection from "../../connection";
import ReactTable from "../../components/ReactTableWrapper";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import EstadoUtilizador from "../../components/EstadoUtilizador";

import {faPlus, faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import UserSearch from "../../components/UserSearch";
import SweetAlert from "../../components/SweetAlertWrapper";
import CaixaFiltrosAcontecimento, {ProviderFiltrosAcontecimento, WidgetsFiltrosAcontecimento} from "../../components/FiltrosAcontecimento/FiltrosAcontecimento";
import general from "../../general";
import UserDetailsBox from "../../components/UserDetailsBox";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

class Utilizadores extends React.Component {
  createActions(acoes = [], row) {
    let {classes} = this.props;
    return (
      <div className="actions-right">
        {acoes.includes("ver") && <>
          <Button
            justIcon
            round
            simple
            onClick={() => {
              window.App.hist.push("/perfil/" + row.id);
            }}
            style={{margin: 0}}
            color="info"
            className="like"
          >
            <FontAwesomeIcon icon={faSearchPlus}/>
          </Button>{" "}
        </>}
        {acoes.includes("apagar_secretario") && <>
          <Button
            justIcon
            round
            simple
            onClick={(e) => {
              e.stopPropagation();
              this.confirmDeleteSecretario(row.NIN);
            }}
            color="danger"
            className={classes.deleteSecretarioButton}
          >
            <FontAwesomeIcon icon={faTrashAlt}/>
          </Button>{" "}
        </>}
        {acoes.includes("apagar_secretario_nucleo") && !!row.pode_eliminar && <>
          <Button
            justIcon
            round
            simple
            onClick={(e) => {
              e.stopPropagation();
              this.confirmDeleteSecretarioNucleo(row.NIN);
            }}
            color="danger"
            className={classes.deleteSecretarioButton}
          >
            <FontAwesomeIcon icon={faTrashAlt}/>
          </Button>{" "}
        </>}
        {acoes.includes("apagar_tutor") && !!row.pode_eliminar && <>
          <Button
            justIcon
            round
            simple
            onClick={(e) => {
              e.stopPropagation();
              this.confirmDeleteTutor(row.NIN);
            }}
            color="danger"
            className={classes.deleteTutorButton}
          >
            <FontAwesomeIcon icon={faTrashAlt}/>
          </Button>{" "}
        </>}
        {acoes.includes("apagar_assistente") && !!row.pode_eliminar && <>
          <Button
            justIcon
            round
            simple
            onClick={(e) => {
              e.stopPropagation();
              this.confirmDeleteCargoTemporario(row);
            }}
            color="danger"
            className={classes.deleteTutorButton}
          >
            <FontAwesomeIcon icon={faTrashAlt}/>
          </Button>{" "}
        </>}
      </div>
    )
  }
  constructor(props) {
    super(props);

    let url = "utilizador/listagem";
    let acoes = true;
    let type = "Utilizadores";
    let tipo_pagina = "utilizadores";
    let lista_filtros = ['regiao', 'nucleo', 'agrupamento'];
    switch (window.location.pathname) {
      case "/adultos":
        url += "/formandos";
        type = "Adultos";
        acoes = ["ver"];
        tipo_pagina = "adultos";
        lista_filtros = ['regiao', 'nucleo', 'agrupamento', 'tipo_utilizador', 'mostrar_inativos'];
        break;
      case "/outros-utilizadores":
        type = "Outros";
        url += "/outros";
        acoes = ["ver"];
        tipo_pagina = "outros";
        lista_filtros = ['regiao', 'nucleo', 'agrupamento', 'tipo_utilizador'];
        break;
      case "/secretarios-regionais":
        type = "Secretários Regionais";
        url += "/secretarios_regionais";
        acoes = ["apagar_secretario"];
        tipo_pagina = "secretarios_regionais";
        break;
      case "/secretarios-nucleo":
        type = "Secretários de Núcleo";
        url += "/secretarios_nucleo";
        acoes = ["apagar_secretario_nucleo"];
        tipo_pagina = "secretarios_nucleo";
        break;
      case "/tutores-locais":
        type = "Tutores Locais";
        url += "/tutores_locais";
        acoes = ["apagar_tutor"];
        tipo_pagina = "tutores_locais";
        break;
      case "/cargos_temporarios":
        type = "Cargos Temporários";
        url += "/cargos_temporarios";
        acoes = ["apagar_assistente"];
        tipo_pagina = "cargos_temporarios";
        lista_filtros = ['regiao', 'nucleo', 'agrupamento', 'tipo_utilizador'];
        break;
      case "/tutorandos":
        url += "/tutorandos";
        type = "Tutorandos";
        acoes = ["ver", "mostrar_detalhes"];
        tipo_pagina = "tutorandos";
        break;
      case "/utilizadores_em_percurso":
        url += "/utilizadores_em_percurso";
        type = "Adultos em Percurso";
        acoes = ["ver", "mostrar_detalhes"];
        tipo_pagina = "utilizadores_em_percurso";
        break;
      default:
        break;
    }

    this.state = {
      data: null,
      type: type,
      acoes: acoes,
      endpoint: url,
      loading: false,
      tipo_pagina: tipo_pagina,
      lista_filtros: lista_filtros,
      page: 0,
      pageSize: 50
    };

    this.createActions = this.createActions.bind(this);
  }

  render() {
    return <this.Content/>
  }

  fetchData(state) {
    this.setState({loading: true});
    connection.get(this.state.endpoint, {
      pagina: state.page ?? this.state.page,
      numero_resultados: state.pageSize ?? this.state.pageSize,
      sorted: state.sorted ?? this.state.sorted,
      filter: state.searchTable ?? this.state.searchTable,
      filtro: state.filtros ?? this.state.filtros
    }, (data) => {
      this.setState({
        data: data.users,
        pages: data.paginacao.paginas,
        loading: false,
        sorted: state.sorted ?? this.state.sorted,
        page: state.page ?? this.state.page,
        pageSize: state.pageSize ?? this.state.pageSize,
        filtros: state.filtros ?? this.state.filtros,
        searchTable: state.searchTable ?? this.state.searchTable
      })
    })
  }

  Content = () => {
    const {classes} = this.props;

    const defaultFilters = useMemo(() => {
      if (window.location.pathname === '/adultos') {
        if (general.userHasType("secretario_regional")) {
          return {regiao: [window.App.state.user.regiao]};
        } else if (general.userHasType("secretario_nucleo")) {
          return {nucleo: [window.App.state.user.nucleo]};
        } else if (general.userHasType("chefe_agrupamento")) {
          return {agrupamento: [window.App.state.user.agrupamento]};
        }
      }

      if (window.location.pathname === '/utilizadores_em_percurso' && general.userHasType("chefe_agrupamento"))
        return {agrupamento: [window.App.state.user.agrupamento]};

      return null;
    }, []);

    let columns = [
      {
        Header: "Nome",
        accessor: "nome",
        Cell: (row) => <span>
          <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
          <span style={{fontSize: 10, display: "block", marginTop: -3, color: "#5e5e5e"}}>{row.original.agrupamento + (row.original.nucleo ? " / " + row.original.nucleo : '') + (row.original.regiao ? " / " + row.original.regiao : '')}</span>
        </span>
      }];
    if (window.location.pathname === '/secretarios-regionais')
      columns.push({
        Header: "Região",
        accessor: "regiao",
        maxWidth: 300
      });
    if (window.location.pathname === '/adultos')
      columns.push({
        Header: "Categoria",
        accessor: "categoria",
        maxWidth: 300
      });
    if (window.location.pathname === '/tutorandos')
      columns.push({
        Header: "Categoria",
        accessor: "categoria",
        maxWidth: 300
      });
    if (window.location.pathname === '/utilizadores_em_percurso')
      columns.push({
        Header: "Categoria",
        accessor: "categoria",
        maxWidth: 300
      });
    columns.push({
      Header: "NIN",
      accessor: "NIN",
      maxWidth: 160
    });
    if (window.location.pathname === '/outros-utilizadores' || window.location.pathname === '/cargos_temporarios' || window.location.pathname === '/adultos')
      columns.push({
        Header: "Tipo",
        id: "tipos",
        maxWidth: 300,
        accessor: "tipos"
      });

    this.state.acoes?.length > 0 && columns.push({
      Header: "",
      sortable: false,
      filterable: false,
      maxWidth: 60,
      Cell: (row) => this.createActions(this.state.acoes, row.original)
    });

    const pesquisarUtilizador = async (filtro, pesquisa = null) => {
      let filtragem = {...filtro}

      for (let key in filtragem)
        if (!filtragem[key] || filtragem[key].length === 0) delete filtragem[key];

      this.fetchData({page: 0, pageSize: this.state.pageSize, filtros: filtragem, searchTable: pesquisa});
    }

    return (
      <GridContainer>
        <GridItem xs={12}>
          <ProviderFiltrosAcontecimento acontecimento={'utilizadores'} pagina={this.state.tipo_pagina}
                                        atualizar={pesquisarUtilizador}
                                        lista_filtros={this.state.lista_filtros}
                                        separador={this.state.tipo_pagina}
                                        defaultFilters={defaultFilters}>
            <Card>
              <CardHeader color="primary">
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                  <h4 style={{flex: 1}}>{this.state.type}</h4>
                  <WidgetsFiltrosAcontecimento/>
                  {window.location.pathname === "/secretarios-regionais" && <Button
                    className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
                    onClick={() => this.adicionarSecretario()}
                    color="success"
                  >
                    <FontAwesomeIcon icon={faPlus}/> Adicionar
                  </Button>}
                  {window.location.pathname === "/secretarios-nucleo" && general.userHasPermission("utilizador.editar_secretarios_nucleo") && <Button
                    className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
                    onClick={() => this.adicionarSecretarioNucleo()}
                    color="success"
                  >
                    <FontAwesomeIcon icon={faPlus}/> Adicionar
                  </Button>}
                  {window.location.pathname === "/tutores-locais" && general.userHasPermission("utilizador.editar_tutores_locais") && <Button
                    className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
                    onClick={() => this.adicionarTutor()}
                    color="success"
                  >
                    <FontAwesomeIcon icon={faPlus}/> Adicionar
                  </Button>}
                  {window.location.pathname === "/cargos_temporarios" && general.userHasPermission("utilizador.editar_cargos_temporarios") && <Button
                    className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
                    onClick={() => this.adicionarCargoTemporario()}
                    color="success"
                  >
                    <FontAwesomeIcon icon={faPlus}/> Adicionar
                  </Button>}
                </div>
              </CardHeader>
              {<CaixaFiltrosAcontecimento/>}
              <ReactTable
                data={this.state.data || []}
                minRows={1}
                SubComponent={["/tutorandos", "/utilizadores_em_percurso"].includes(window.location.pathname) ? ((row) => <UserDetailsBox detalhes_progresso={row.original} progresso_candidato={true} percursos_em_progresso={row.original.percursos} cursos_em_progresso={row.original.cursos}/>) : null}
                columns={columns}
                defaultPageSize={this.state.pageSize}
                showPaginationBottom={true}
                className="-striped -highlight"
                loading={this.state.loading}
                pages={this.state.pages}
                manual
                onFetchData={(state) => {
                  if (this.state.data)
                    this.fetchData({page: state.page, pageSize: state.pageSize, sorted: state.sorted});
                }}
              />
            </Card></ProviderFiltrosAcontecimento>
        </GridItem>
      </GridContainer>
    );
  }

  adicionarSecretario() {
    const {classes} = this.props;

    let utilizador = null;

    let Content = () => {
      return <form autoComplete="off" className={classes.alertForm}>
        <UserSearch
          labelText="NIN do Secretário"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            name: "secretario"
          }}
          onFoundUser={(user) => {
            utilizador = user.NIN;
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Novo Secretário Regional</span>
      </div>)}
      onConfirm={() => {
        connection.post("utilizador/adicionar/secretario_regional", {secretario: utilizador}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Adicionar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }

  confirmDeleteSecretario(secretario) {
    window.App.openModal(<SweetAlert
      warning
      title="Remover Secretário Regional"
      onConfirm={() => {
        connection.post("utilizador/remover/secretario_regional", {secretario: secretario}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.danger
      }
      cancelBtnCssClass={
        this.props.classes.button
      }
      confirmBtnText="Remover"
      cancelBtnText="Cancelar"
      showCancel
    >
      Tem a certeza que pretende remover o cargo 'Secretário Regional' do NIN {secretario}?
    </SweetAlert>);
  }

  adicionarSecretarioNucleo() {
    const {classes} = this.props;

    let utilizador = null;

    let Content = () => {
      return <form autoComplete="off" className={classes.alertForm}>
        <UserSearch
          labelText="NIN do Secretário"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            name: "secretario"
          }}
          onFoundUser={(user) => {
            utilizador = user.NIN;
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Novo Secretário de Núcleo</span>
      </div>)}
      onConfirm={() => {
        connection.post("utilizador/adicionar/secretario_nucleo", {secretario: utilizador}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Adicionar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }

  confirmDeleteSecretarioNucleo(secretario) {
    window.App.openModal(<SweetAlert
      warning
      title="Remover Secretário de Núcleo"
      onConfirm={() => {
        connection.post("utilizador/remover/secretario_nucleo", {secretario: secretario}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.danger
      }
      cancelBtnCssClass={
        this.props.classes.button
      }
      confirmBtnText="Remover"
      cancelBtnText="Cancelar"
      showCancel
    >
      Tem a certeza que pretende remover o cargo 'Secretário de Núcleo' do NIN {secretario}?
    </SweetAlert>);
  }

  adicionarTutor() {
    const {classes} = this.props;

    let utilizador = null;

    let Content = () => {
      return <form autoComplete="off" className={classes.alertForm}>
        <UserSearch
          labelText="NIN do Tutor"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            name: "tutor"
          }}
          onFoundUser={(user) => {
            utilizador = user.NIN;
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Novo Tutor Local</span>
      </div>)}
      onConfirm={() => {
        connection.post("utilizador/adicionar/tutor_local_forcado", {tutor: utilizador}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Adicionar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }

  confirmDeleteTutor(tutor) {
    window.App.openModal(<SweetAlert
      warning
      title="Remover Tutor Local"
      onConfirm={() => {
        connection.post("utilizador/remover/tutor_local_forcado", {tutor: tutor}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.danger
      }
      cancelBtnCssClass={
        this.props.classes.button
      }
      confirmBtnText="Remover"
      cancelBtnText="Cancelar"
      showCancel
    >
      Tem a certeza que pretende remover o cargo 'Tutor Local' do NIN {tutor}?
    </SweetAlert>);
  }

  async adicionarCargoTemporario() {
    const {classes} = this.props;

    let utilizador = null;
    let cargo_temporario = null;

    let cargos_temporarios = await connection.get("utilizador/cargos_temporarios");

    let Content = () => {
      const [cargoForcado, setCargoForcado] = useState(null);

      return <form autoComplete="off" className={classes.alertForm}>

        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="tipo_percurso" className={classes.selectLabel}>
            Forçar Cargo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={cargoForcado}
            onChange={(event) => {
              cargo_temporario = event.target.value;
              setCargoForcado(event.target.value);
            }}
            inputProps={{
              name: "cargo_temporario",
              id: "cargo_temporario"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o cargo</MenuItem>
            {cargos_temporarios.map((cargo) => {
              return <MenuItem key={cargo.id} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={cargo.codigo}>{cargo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <UserSearch
          labelText="NIN do utilizador"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            name: "tutor"
          }}
          onFoundUser={(user) => {
            utilizador = user.NIN;
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Atribuir Cargo Temporário</span>
      </div>)}
      onConfirm={() => {
        connection.post("utilizador/adicionar/cargos_temporarios", {nin_utilizador: utilizador, cargo_temporario: cargo_temporario}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Adicionar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }

  async confirmDeleteCargoTemporario(row) {
    const {classes} = this.props;

    let utilizador = null;
    let cargo_temporario = null;

    let cargos_temporarios = await connection.get("utilizador/cargos_temporarios");
    let tipos_temporarios = row.tipos_temporarios.split(', ');

    // Deixar na lista de cargos que podem ser removidos apenas os cargos temporários atribuídos ao utilizador
    cargos_temporarios = cargos_temporarios.filter(cargo => tipos_temporarios.includes(cargo.codigo));

    let Content = () => {
      const [cargoForcado, setCargoForcado] = useState(null);

      return <form style={{marginTop: "0px"}} autoComplete="off" className={classes.alertForm}>

        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="tipo_percurso" className={classes.selectLabel}>
            Remover cargo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={cargoForcado}
            onChange={(event) => {
              cargo_temporario = event.target.value;
              setCargoForcado(event.target.value);
            }}
            inputProps={{
              name: "cargo_temporario",
              id: "cargo_temporario"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o cargo</MenuItem>
            {cargos_temporarios.map((cargo) => {
              return <MenuItem key={cargo.id} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={cargo.codigo}>{cargo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </form>;
    };

    window.App.openModal(<SweetAlert
      warning
      title="Remover"
      onConfirm={() => {
        connection.post("utilizador/remover/cargos_temporarios", {nin_utilizador: row.NIN, cargo_temporario: cargo_temporario}, (data) => {
          window.App.hideModal();
          this.fetchData({page: 0, pageSize: this.state.pageSize});
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.danger
      }
      cancelBtnCssClass={
        this.props.classes.button
      }
      confirmBtnText="Remover"
      cancelBtnText="Cancelar"
      showCancel
    >
      Selecione abaixo o cargo temporário a ser removido do utilizador com o NIN {row.NIN}?
      <Content/>
    </SweetAlert>);
  }
}

export default withStyles(usersStyle)(Utilizadores);
